module.exports = __webpack_public_path__ + "static/media/cover-sample.b00d2c21.jpg";